import React from 'react';
import classnames from 'classnames';
import styles from './link.css';

interface LinkProps {
  /** Content of the link */
  children: React.ReactNode;
  /** Adds additional classes to the component. */
  className?: string;
  /** URL where the user will be redirected when the link is clicked on */
  href?: string;
  /** Sets the target of the a tag */
  target?: '_blank' | '_self' | '_parent' | '_top';
  /** Provides visual elements for usage on dark environment */
  darkEnv?: boolean;
  /** Callback when clicked */
  onClick?: (e: React.MouseEvent) => void;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Link Component
 *
 * @param {LinkProps} props
 *
 * @returns JSX.ELEMENT
 */
export const Link = ({
  children,
  className,
  href,
  target = '_self',
  darkEnv,
  onClick,
  'data-testid': dataTestId
}: LinkProps) => {
  const linkClasses = classnames(className, styles.link, {
    [styles.darkEnv]: darkEnv
  });

  return (
    <a
      className={linkClasses}
      {...(href && { href })}
      {...(target && { target })}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </a>
  );
};

export default Link;
